"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.createTable(_globals.MetaTable.COL_QRCODE, (table)=>{
        table.string('id', 20).primary().notNullable();
        table.string('fk_column_id', 20);
        table.foreign('fk_column_id').references(`${_globals.MetaTable.COLUMNS}.id`);
        table.string('fk_qr_value_column_id', 20);
        table.foreign('fk_qr_value_column_id').references(`${_globals.MetaTable.COLUMNS}.id`);
        table.boolean('deleted');
        table.float('order');
        table.timestamps(true, true);
    });
};
const down = async (knex)=>{
    await knex.schema.dropTable(_globals.MetaTable.COL_QRCODE);
};
